const updateContactNumber = (data, contact) => {
  const { prop } = data;
  const { val } = data;
  if (val?.length === 10 && parseInt(val, 0) && !val.includes('-')) {
    // eslint-disable-next-line no-param-reassign
    contact[prop] = `${val.slice(0, 3)}-${val.slice(3, 6)}-${val.slice(6)}` ?? null;
  } else {
    // eslint-disable-next-line no-param-reassign
    contact[prop] = val ?? null;
  }
};

const updateContactInfo = (data, contact) => {
  if (data) {
    let name = null;
    if (data.name) {
      name = data.name.trim().split(' ');
    } else if (data.fName) {
      name = `${data.fName} ${data.lName}`.trim().split(' ');
    }
    if (name) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      contact.fName = name[0];
      // eslint-disable-next-line no-param-reassign
      contact.lName = name.slice(1).toString().replace(',', '');
    } else {
      // eslint-disable-next-line no-param-reassign
      contact.fName = null;
      // eslint-disable-next-line no-param-reassign
      contact.lName = null;
    }
    if (data?.ownerContactID || data?.contactId) {
      // eslint-disable-next-line no-param-reassign
      contact.email = data.emailAddress ?? null;
      // eslint-disable-next-line no-unused-expressions, no-param-reassign
      (data.phoneNumber) ? updateContactNumber({ prop: 'phone', val: data.phoneNumber }, contact) : contact.phone = null;
    }
  }
};

const updateContactFieldDS = (thiss, dataSource, contact, prop = null) => {
  // console.log("contact", contact);
  // eslint-disable-next-line no-param-reassign
  thiss[prop || 'contactFieldDataSource'] = dataSource;
  // eslint-disable-next-line no-param-reassign, no-multi-assign
  contact.fName = contact.lName = contact.email = contact.phone = null;
};

export {
  updateContactNumber,
  updateContactInfo,
  updateContactFieldDS,
};
